import React, {
    Component, forwardRef, useState, useEffect
} from 'react';
import { Breadcrumb } from "components";
import { translate } from "react-switch-lang";
import { AddBox, ArrowDownward } from '@material-ui/icons';
import MaterialTable from 'material-table';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import CircularProgress from '@material-ui/core/CircularProgress';
import PrintIcon from '@material-ui/icons/Print';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import TableToolbar from 'components/tableToolbar';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    print: forwardRef((props, ref) => <PrintIcon {...props} ref={ref} />),
    DownloadTable: forwardRef((props, ref) => (
        <CloudDownloadOutlinedIcon
            style={{ fontSize: 'larger', fontWeight: 'bolder' }}
            {...props}
            ref={ref}
        />
    ))
};

const data1 = [
    {
        product: 'HBB',
        unsatStart: 'min',
        unsatEnd: '75',
        almostStart: '76',
        almostEnd: '95',
        achievedStart: '96',
        achievedEnd: '110',
        wellStart: '111',
        wellEnd: '139',
        outStart: '140',
        outEnd: 'max',
    },
    {
        product: 'Baqati',
        unsatStart: 'min',
        unsatEnd: '75',
        almostStart: '76',
        almostEnd: '95',
        achievedStart: '96',
        achievedEnd: '110',
        wellStart: '111',
        wellEnd: '139',
        outStart: '140',
        outEnd: 'max',
    },
    {
        product: 'Hayyak',
        unsatStart: 'min',
        unsatEnd: '75',
        almostStart: '76',
        almostEnd: '95',
        achievedStart: '96',
        achievedEnd: '110',
        wellStart: '111',
        wellEnd: '139',
        outStart: '140',
        outEnd: 'max',
    },
    {
        product: 'Upgrade',
        unsatStart: 'min',
        unsatEnd: '75',
        almostStart: '76',
        almostEnd: '95',
        achievedStart: '96',
        achievedEnd: '110',
        wellStart: '111',
        wellEnd: '139',
        outStart: '140',
        outEnd: 'max',
    },
];

const ScaleManagement = (props) => {
    const { locale } = props;
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState(data1)


    return (
        <>
         <Breadcrumb title={props.t("Scale Management")} />
        <div className="app-wrapper">
            <div>
                {loader ? (
                    <div
                        className="loader-view"
                        style={{
                            height:
                                props.width >= 1200
                                    ? 'calc(100vh - 259px)'
                                    : 'calc(100vh - 238px)'
                        }}
                    >
                        <CircularProgress />
                    </div>
                ) : (
                    <div className="animated slideInUpTiny animation-duration-3">
                        <MaterialTable
                            icons={tableIcons}
                            columns={[
                                { title: props.t('Product Name'), field: 'product' },
                                { title: props.t('Unsatisfactory-Start'), field: 'unsatStart' },
                                { title: props.t('Unsatisfactory-End'), field: 'unsatEnd' },
                                { title: props.t('Almost Achieved-Start'), field: 'almostStart' },
                                { title: props.t('Almost Achieved-End'), field: 'almostEnd' },
                                { title: props.t('Achieved-Start'), field: 'achievedStart' },
                                { title: props.t('Achieved-End'), field: 'achievedEnd' },
                                { title: props.t('Well Achieved-Start'), field: 'wellStart' },
                                { title: props.t('Well Achieved-End'), field: 'wellEnd' },
                                { title: props.t('Outstanding-Start'), field: 'outStart' },
                                { title: props.t('Outstanding-End'), field: 'outEnd' },


                            ]}
                            data={data}
                            options={{
                                actionsColumnIndex: -1,
                                addRowPosition: 'first',
                                filtering: true,
                                showTitle: false,
                                sorting: true
                            }}
                            // actions={[
                            //     {
                            //         icon: tableIcons.DownloadTable,
                            //         tooltip: 'Download CSV',
                            //         isFreeAction: true,
                            //         //   onClick: handleExportList,
                            //     },
                            //     {
                            //         icon: tableIcons.print,
                            //         tooltip: 'Print Table',
                            //         isFreeAction: true,
                            //         //   onClick: handlePdfDownload,
                            //     },
                            // ]}
                            localization={{
                                header: {
                                  actions: props.t("Action"),
                                },
                              }}
                            editable={{
                                onRowAdd: newData => new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        setData([...data, newData]);

                                        resolve();
                                    }, 1000);
                                }),
                                onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        const dataUpdate = [...data];
                                        const index = oldData.tableData.id;
                                        dataUpdate[index] = newData;
                                        setData([...dataUpdate]);

                                        resolve();
                                    }, 1000);
                                }),
                                onRowDelete: oldData => new Promise((resolve, reject) => {
                                    setTimeout(() => {
                                        const dataDelete = [...data];
                                        const index = oldData.tableData.id;
                                        dataDelete.splice(index, 1);
                                        setData([...dataDelete]);

                                        resolve();
                                    }, 1000);
                                }),
                            }}
                            components={{
                                Toolbar: (propsToolbar) => (
                                  <TableToolbar {...propsToolbar} t={props.t} />
                                ),
                              }}
                        />
                    </div>
                )}
            </div>
        </div>
        </>
    );
};

export default translate(ScaleManagement);
